import React, { useState } from "react";
import "../styles/Dashboard.css";

const Dashboard = () => {
  const [savedJobs] = useState([
    { title: "Software Engineer", company: "Google", location: "Remote" },
    { title: "Data Scientist", company: "Amazon", location: "Bangalore" },
  ]);

  const [appliedJobs] = useState([
    { title: "Frontend Developer", company: "Amazon", status: "Under Review" },
    { title: "AI Engineer", company: "Microsoft", status: "Interview Scheduled" },
  ]);

  const [alerts] = useState([
    "New Backend Developer job at Meta",
    "Product Manager role at Netflix",
    "DevOps Engineer opening at Tesla",
  ]);

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <aside className="sidebar">
        <h2>Dashboard</h2>
        <ul>
          <li>📁 Saved Jobs</li>
          <li>✅ Applied Jobs</li>
          <li>🔔 Job Alerts</li>
          <li>👤 Profile</li>
        </ul>
      </aside>

      {/* Main Dashboard Content */}
      <div className="dashboard-content">
        <h1>My Dashboard</h1>

        {/* Saved Jobs */}
        <section className="saved-jobs">
          <h2>📁 Saved Jobs</h2>
          {savedJobs.map((job, index) => (
            <div key={index} className="job-card">
              <p><strong>{job.title}</strong> - {job.company} ({job.location})</p>
            </div>
          ))}
        </section>

        {/* Applied Jobs */}
        <section className="applied-jobs">
          <h2>✅ Applied Jobs</h2>
          {appliedJobs.map((job, index) => (
            <div key={index} className="job-card">
              <p><strong>{job.title}</strong> - {job.company} <span className="status">{job.status}</span></p>
            </div>
          ))}
        </section>

        {/* Job Alerts */}
        <section className="alerts">
          <h2>🔔 Job Alerts</h2>
          <ul>
            {alerts.map((alert, index) => (
              <li key={index}>{alert}</li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Dashboard;
